import { render, staticRenderFns } from "./b-footer.global.vue?vue&type=template&id=6ec2fe84"
import script from "./b-footer.global.vue?vue&type=script&lang=js"
export * from "./b-footer.global.vue?vue&type=script&lang=js"
import style0 from "./b-footer.global.vue?vue&type=style&index=0&id=6ec2fe84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VDivider,VIcon})
